import { EdlSelectOption } from '../model/common/edl-select-option.model';
import { UserRequestFilterStatus } from '../enums/user-request/user-request-filter-status.enum';
import { USER_REQUEST_FILTER_LABELS } from './user-request.constants';
import { AupRequestItemStatus } from '../all-users-progress/common/enums/aup-request-item-status.enum';

export const CPL_ITEM_STATUS_FILTERS = [
    { value: -1, label: 'Priority', disabled: false },
    { value: -2, label: 'A-Z', disabled: false },
    { value: -4, label: 'Due Date', disabled: false },
    { value: null, label: '-------------', disabled: true },
    { value: -3, label: 'Archived', disabled: false },
    { value: null, label: '-------------', disabled: true },
    { value: -5, label: 'Waiting on User', disabled: false },
    { value: 0, label: 'Not Expiring', disabled: false },
    { value: 2, label: 'Expiring', disabled: false },
    { value: 4, label: 'Expired', disabled: false },
    { value: 9, label: 'Expired (All Cycles)', disabled: false },
    { value: 3, label: 'Pending', disabled: false },
    { value: 6, label: 'Disapproved', disabled: false },
    { value: 7, label: 'Forgiven', disabled: false },
    { value: 1, label: 'Approved', disabled: false }
];

const USER_REQUEST_STATUS_FILTERS_ALL: EdlSelectOption<UserRequestFilterStatus | null>[] = [
    { value: UserRequestFilterStatus.Priority, label: 'Priority', disabled: false },
    { value: UserRequestFilterStatus.AZ, label: 'A-Z', disabled: false },
    { value: UserRequestFilterStatus.DueDate, label: 'Due Date', disabled: false },
    { value: UserRequestFilterStatus.Active, label: 'Active', disabled: false },
    { value: null, label: '-------------', disabled: true },
    { value: UserRequestFilterStatus.Archived, label: 'Archived', disabled: false },
    { value: null, label: '-------------', disabled: true },
    { value: UserRequestFilterStatus.Draft, label: 'Draft', disabled: false },
    { value: UserRequestFilterStatus.SubmittedPending, label: 'Submitted/Pending', disabled: false },
    { value: UserRequestFilterStatus.WaitingOnFollowUp, label: 'Waiting on Follow Up', disabled: false },
    { value: UserRequestFilterStatus.FollowUpNotExpiring, label: 'Follow Up Not Expiring', disabled: false },
    { value: UserRequestFilterStatus.FollowUpExpiring, label: 'Follow Up Expiring', disabled: false },
    { value: UserRequestFilterStatus.FollowUpExpired, label: 'Follow Up Expired', disabled: false },
    { value: UserRequestFilterStatus.FollowUpSubmitted, label: 'Follow Up Submitted', disabled: false },
    { value: UserRequestFilterStatus.FollowUpForgiven, label: 'Follow Up Forgiven', disabled: false },
    { value: UserRequestFilterStatus.Disapproved, label: 'Disapproved', disabled: false },
    { value: UserRequestFilterStatus.Completed, label: 'Completed', disabled: false },
    { value: UserRequestFilterStatus.Cancelled, label: 'Cancelled', disabled: false }
];

const setLabels = <T>(filters: EdlSelectOption<T>[], labelOverrides: { value: T, label: string }[]): EdlSelectOption<T>[] => {
    const overrideMap = new Map(labelOverrides.map(o => [o.value, o.label]));
    return filters.map(f => overrideMap.has(f.value) ? { ...f, label: overrideMap.get(f.value) } : f);
};

export const REQUEST_ITEM_EDIT_STATUS_FILTERS: EdlSelectOption<UserRequestFilterStatus | null>[] = setLabels(
    USER_REQUEST_STATUS_FILTERS_ALL.filter(status =>
        ![UserRequestFilterStatus.Active, UserRequestFilterStatus.Draft].includes(status.value)
    ),
    [{ value: UserRequestFilterStatus.Archived, label: USER_REQUEST_FILTER_LABELS.ARCHIVED_FOR_SUPERVISORS }]
);

const EXCLUDED_FROM_SUBMISSIONS_STATUS_FILTERS = [UserRequestFilterStatus.Priority, UserRequestFilterStatus.AZ, UserRequestFilterStatus.DueDate];

export const SUBMISSIONS_SUPERVISOR_STATUS_FILTERS: EdlSelectOption<UserRequestFilterStatus | null>[] = setLabels(
    USER_REQUEST_STATUS_FILTERS_ALL.filter(status =>
        !EXCLUDED_FROM_SUBMISSIONS_STATUS_FILTERS.includes(status.value)
    ),
    [{ value: UserRequestFilterStatus.Archived, label: USER_REQUEST_FILTER_LABELS.ARCHIVED_FOR_SUPERVISORS }]
);

export const SUBMISSIONS_MY_ITEMS_STATUS_FILTERS: EdlSelectOption<UserRequestFilterStatus | null>[] = setLabels(
    USER_REQUEST_STATUS_FILTERS_ALL.filter(status =>
        !EXCLUDED_FROM_SUBMISSIONS_STATUS_FILTERS.includes(status.value)
    ),
    [{ value: UserRequestFilterStatus.Archived, label: USER_REQUEST_FILTER_LABELS.ARCHIVED_FOR_MYSELF }]
);

const REQUESTS_TAB_STATUS_FILTERS: EdlSelectOption<AupRequestItemStatus>[] = [
    { value: AupRequestItemStatus.Active, label: 'Active' },
    { value: AupRequestItemStatus.Archived, label: 'Archived' },
];

export const REQUESTS_TAB_SUPERVISOR_STATUS_FILTERS: EdlSelectOption<AupRequestItemStatus>[] =
    setLabels(REQUESTS_TAB_STATUS_FILTERS, [{ value: AupRequestItemStatus.Archived, label: USER_REQUEST_FILTER_LABELS.ARCHIVED_FOR_SUPERVISORS }]);

export const REQUESTS_TAB_MY_ITEMS_STATUS_FILTERS: EdlSelectOption<AupRequestItemStatus>[] =
    setLabels(REQUESTS_TAB_STATUS_FILTERS, [{ value: AupRequestItemStatus.Archived, label: USER_REQUEST_FILTER_LABELS.ARCHIVED_FOR_MYSELF }]);

export const A48_STATUS_FILTERS: EdlSelectOption<number | null>[] = [
    { value: null, label: 'Act 48 - All', disabled: false },
    { value: -1, label: 'Not Submitted', disabled: false },
    { value: 0, label: 'Overridden', disabled: false },
    { value: 1, label: 'Pending Submission', disabled: false },
    { value: 2, label: 'Error on Submission', disabled: false },
    { value: 3, label: 'Submitted to PERMS', disabled: false },
    { value: 5, label: 'Para Hours Approved', disabled: false },
    { value: 6, label: 'Excluded from Submission', disabled: false }
];
